import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import lemmaMap from './lemma-map.json';

export const UNITS = [
    "kg","g","dag","l","ml", "litr", "litra", "oz",
    "łyżka","łyżki","łyżek","łyżeczkę","łyżeczka","łyżeczki",
    "szt","sztuk","szkl","szklanki", "szklanek", "szklanka",
    "cm","mm","krople","ząbek","ząbki", "ząbków",
    "arkusz", "arkusze", "łodyga", "łodygi", "duży", "garście", "garści",
    "szczypta", "szczypty", "szczypt",
    "puszka","puszki", "puszek", "cup", "cups",
    "lb", "lbs", "pound", "pounds", "inch", "inches",
    "tbsp", "tablespoon", "tablespoons", "tsp", "teaspoon", "teaspoons",
    "fl oz", "fluid ounce", "fluid ounces", "pt", "pint", "pints",
    "qt", "quart", "quarts", "gal", "gallon", "gallons",
    "clove", "cloves", "stalk", "stalks", "piece", "pieces",
    "slice", "slices", "head", "heads", "bunch", "bunches",
    "can", "cans", "jar", "jars", "package", "packages", "pkg",
    "container", "containers"
];
// Importujemy mapę lematyzacji z pliku JSON
const STATIC_LEMMA_MAP = lemmaMap;
let dynamicLemmaMap = { ...STATIC_LEMMA_MAP };

export const fetchRemoteLemmas = async () => {
    try {
        const querySnapshot = await getDocs(collection(db, "lemmaMap"));
        const remoteMap = {};
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            if (data.word && data.lemma) {
                remoteMap[data.word.toLowerCase()] = data.lemma.toLowerCase();
            }
        });
        
        // Łączymy statyczną mapę z danymi z Firestore (Firestore ma priorytet)
        dynamicLemmaMap = { ...STATIC_LEMMA_MAP, ...remoteMap };
        
        // Czyścimy cache, ponieważ mapa się zmieniła
        normalizationCache.clear();
        
        return dynamicLemmaMap;
    } catch (error) {
        console.error("Error fetching lemma map from Firestore:", error);
        return STATIC_LEMMA_MAP;
    }
};

// Cache dla znormalizowanych składników
const normalizationCache = new Map();
const MAX_CACHE_SIZE = 1000;

export function normalizeIngredient(raw) {
    if (typeof raw === "object") {
        raw = raw.name;
    }
    // Sprawdź cache
    const cacheKey = String(raw || "").toLowerCase();
    if (normalizationCache.has(cacheKey)) {
        return normalizationCache.get(cacheKey);
    }

    const cleaned = cacheKey
        .replace(
            new RegExp("^\\s*(?:\\d+(?:[.,]\\d+)?|\\d+\\s*/\\s*\\d+|(?:1/2|1/3|2/3|1/4|3/4)|(?:[½¼¾]|pół|połówka|połówki|ćwierć|ćwiartka))\\s*(?:"+UNITS.join("|")+")?\\s+","i"),
            ""
        )
        .replace(
            new RegExp("\\s+\\d+(?:[.,]\\d+)?\\s*(?:"+UNITS.join("|")+")?\\s*$","i"),
            ""
        )
        .replace(/[.,]/g,"")
        .trim();

    const key = cleaned;
    let result = dynamicLemmaMap[key] || findInFridge(key);

    // Zapisz w cache (z ograniczeniem rozmiaru)
    if (normalizationCache.size >= MAX_CACHE_SIZE) {
        // Usuń najstarszy wpis
        const firstKey = normalizationCache.keys().next().value;
        normalizationCache.delete(firstKey);
    }
    normalizationCache.set(cacheKey, result);

    return result;
}

function findInFridge(result) {
    // Sortuj klucze według długości (najdłuższe pierwsze), aby najpierw zastępować
    // bardziej specyficzne frazy
    const sortedKeys = Object.keys(dynamicLemmaMap).sort((a, b) => b.length - a.length);

    for (const mapKey of sortedKeys) {
        // Sprawdź czy fragment występuje w składniku
        if (result.includes(mapKey)) {
            const lemmatized = dynamicLemmaMap[mapKey];
            // Zastąp wszystkie wystąpienia fragmentu zlematyzowaną formą
            // tu dodałem szybki fix, trzeba jeszcze sprawdzić kilka przypadków dopasowywanie fragmentów w lini
            // składników, dodatkowo sprawdzić czy lematyzacja poszczególnych słów działa
            if (result !== lemmatized) {
                result = result.split(mapKey).join(lemmatized);
            }
        }
    }

    // Wyczyść podwójne spacje powstałe po zastąpieniach
    result = result.replace(/\s+/g, " ").trim();

    return result;
}